__turbopack_context__.v({
  "container": "jy8AFa_container",
  "inner": "jy8AFa_inner",
  "tooltip": "jy8AFa_tooltip",
});
